// Class
import { SmartTagBase } from './smartTagBase';
// Model
import { SmartTagModel } from './smartTag.model';

export class SmartTagFormRenderEngineModel extends SmartTagModel {
	// [optionName: string]: any;

	constructor() {
		super();
	}
}

export class SmartTagFormRenderEngine extends SmartTagBase {

	/**
	 * Dynamic Renderer
	 * @param data SmartTagUpdateModel
	 */
	public formRender(data: SmartTagFormRenderEngineModel, formControl: any, version?: string): string {
		this.getData(data, formControl);
		return this.getOutputData(version);
	}

	/**
	 *
	 * @param data
	 * @private
	 */
	private getData(data: SmartTagFormRenderEngineModel, formControl: any): void{
		const title = data.title || data.subCategory || '';
		const description = data.description?.trim() || '';

		if (title !== '') {
			this.title = `<span title="${title}">Type: ${title}</span>`;
		}

		// Dynamically get only the params available for the Form
		for (const [key, value] of Object.entries(data)) {
			if (formControl) {
				const param = formControl.find((fc: any) => fc.field === key);
				const dataValue = data[key];
				if (param && dataValue !== null) {
					switch (typeof dataValue) {
						case 'boolean':
							this.addText(`<span title="${param.title}">${param.title}: ${dataValue ? 'Yes':'No'}</span>`);
							break;

						case 'object':
							if ('[object Array]' === Object.prototype.toString.apply(dataValue)) {
								for (const item of dataValue) {
									Object.keys(item).forEach(itemKey => {
										const capitalize = item[itemKey].toLowerCase()
											.split('_')
											.map(word => word.charAt(0).toUpperCase() + word.slice(1))
											.join(' ');
										this.addText(`<span title="${capitalize}">${capitalize}: Yes</span>`);
									});
								}
							}
							break;

						default:
							this.addText(`<span title="${param.title}">${param.title}: ${dataValue}</span>`);
							break;
					}
				}
			}
		}

		if (description !== '') {
			this.addText(`<span title="${description}">Description: ${description}</span>`);
		}
	}
}
